import { useMutation } from '@tanstack/react-query';
import { axiosInstance } from '../../utils';
import { AffiliateData } from './getAffiliates';

export interface UpdateCommissionData {
  commissionAmountPaid?: number;
  clickCommissionPaid?: boolean;
  saleCommissionPaid?: boolean;
}

const updateCommission = async ({ id, data }: { id: string; data: UpdateCommissionData }): Promise<AffiliateData> => {
  const res = await axiosInstance.patch(`/api/affiliates/${id}/commission`, data);
  return res.data;
};

export const useUpdateCommission = () => {
  return useMutation(updateCommission);
};
